import axios from 'axios'
import Vue from 'vue'

const state = {
    filter: {
        projects: [],
        jobs: [],
        tags: [],
        fromDt: null,
        thruDt: null,
        onlyUntagged: true,
        respIdSearchFreeForm: null

    }
}

const getters = {}

const mutations = {
    setFilter(state, filter) {
        Object.assign(state.filter, filter)
    },
    clearFilter(state) {
        state.filter = {
            projects: [],
            jobs: [],
            tags: [],
            fromDt: null,
            thruDt: null,
            onlyUntagged: true,
            respIdSearchFreeForm: null
        }
    },

}


const actions = {
    getPhotosByFilter(context, filter){
        let keys = Object.keys(filter)

        let tagIds = filter.tags.map(i => i.id)
        let jobIds = filter.jobs.map(i => i.id)
        let projIds = filter.projects.map(i => i.id)

        let payload = {
            fromDateVal: filter.fromDt,
            toDateVal: filter.thruDt,
            onlyUntagged: filter.onlyUntagged,
            tags: tagIds,
            jobs: jobIds,
            projects: projIds,
            respIdSearchFreeForm: filter.respIdSearchFreeForm,
            country: filter.country,
            retailer: filter.retailer,
            department: filter.department
        };

        return axios.post('/api/photos/filter_photos/', payload)
            .then(response => {
                this.state.photos.photos = response.data
            })
            .catch(e => {
                console.log(e)
            })
    }

}

export default {
    state,
    getters,
    mutations,
    actions
}
